const menu = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      height={size}
      width={size}
    >
      <path d="M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z" />
    </svg>
  );
};

const menuClose = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
      width={size}
      height={size}
    >
      <path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
    </svg>
  );
};
const bg = ({ size }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 2592 1058"
      enable-background="new 0 0 2592 1058"
      width={size}
      height={size}
    >
      <path d="M2473.711,16.36c0.376,0.196,1.118,0.58,1.493,0.777c0.495-0.265,1.485-0.785,1.98-1.041 " />
    </svg>
  );
};

const team = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.639 26.0526C48.0217 26.0526 50.764 28.8567 50.764 32.3158V43.9474H50.75V44.8421C50.75 46.3245 49.5747 47.5263 48.125 47.5263C46.6753 47.5263 45.5 46.3245 45.5 44.8421V36.7895H45.514V32.3158C45.514 31.8215 45.1223 31.4211 44.639 31.4211H25.3818C24.8985 31.4211 24.5068 31.8215 24.5068 32.3158V43.9474H24.5V44.8421C24.5 46.3245 23.3247 47.5263 21.875 47.5263C20.4253 47.5263 19.25 46.3245 19.25 44.8421V36.7895H19.2568V32.3158C19.2568 28.8567 21.999 26.0526 25.3818 26.0526H44.639ZM64.75 32.3158V44.8421C64.75 46.3245 65.9253 47.5263 67.375 47.5263C68.8247 47.5263 70 46.3245 70 44.8421V32.3158C70 28.8567 67.2577 26.0526 63.875 26.0526L52.0615 26.0493C53.263 27.5361 54.0459 29.39 54.2248 31.4218L63.875 31.4211C64.3583 31.4211 64.75 31.8215 64.75 32.3158ZM0 44.8421C0 46.3245 1.17527 47.5263 2.625 47.5263C4.07473 47.5263 5.25 46.3245 5.25 44.8421V32.3158C5.25 31.8215 5.64175 31.4211 6.125 31.4211L15.7959 31.4218C15.9748 29.39 16.7577 27.5361 17.9595 26.0493L6.125 26.0526C2.74225 26.0526 0 28.8567 0 32.3158V44.8421ZM35 1C40.7992 1 45.5 5.80706 45.5 11.7368C45.5 17.6666 40.7992 22.4737 35 22.4737C29.2008 22.4737 24.5 17.6666 24.5 11.7368C24.5 5.80706 29.2008 1 35 1ZM35 6.36842C32.1006 6.36842 29.75 8.77193 29.75 11.7368C29.75 14.7017 32.1006 17.1053 35 17.1053C37.8994 17.1053 40.25 14.7017 40.25 11.7368C40.25 8.77193 37.8994 6.36842 35 6.36842ZM57.75 4.57895C62.5824 4.57895 66.5 8.58483 66.5 13.5263C66.5 18.4678 62.5824 22.4737 57.75 22.4737C52.9176 22.4737 49 18.4678 49 13.5263C49 8.58483 52.9176 4.57895 57.75 4.57895ZM57.75 9.94737C55.817 9.94737 54.25 11.5497 54.25 13.5263C54.25 15.5029 55.817 17.1053 57.75 17.1053C59.683 17.1053 61.25 15.5029 61.25 13.5263C61.25 11.5497 59.683 9.94737 57.75 9.94737ZM12.25 4.57895C17.0825 4.57895 21 8.58483 21 13.5263C21 18.4678 17.0825 22.4737 12.25 22.4737C7.41751 22.4737 3.5 18.4678 3.5 13.5263C3.5 8.58483 7.41751 4.57895 12.25 4.57895ZM12.25 9.94737C10.317 9.94737 8.75 11.5497 8.75 13.5263C8.75 15.5029 10.317 17.1053 12.25 17.1053C14.183 17.1053 15.75 15.5029 15.75 13.5263C15.75 11.5497 14.183 9.94737 12.25 9.94737ZM2.625 51.1053C1.17527 51.1053 0 52.3071 0 53.7895V55.5789C0 62.9913 5.87626 69 13.125 69H56.875C64.1238 69 70 62.9913 70 55.5789V53.7895C70 52.3071 68.8247 51.1053 67.375 51.1053H2.625ZM13.125 63.6316C9.07151 63.6316 5.73332 60.5 5.29806 56.4737H64.702C64.2666 60.5 60.9284 63.6316 56.875 63.6316H13.125Z"
        fill="#212121"
      />
    </svg>
  );
};
const profil = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.5 8.75C40.1063 8.75 43.875 12.6875 43.875 17.5C43.875 22.3125 40.1063 26.25 35.5 26.25C30.8937 26.25 27.125 22.3125 27.125 17.5C27.125 12.6875 30.8937 8.75 35.5 8.75ZM35.5 52.5C46.8063 52.5 59.7875 58.1438 60.625 61.25H10.375C11.3381 58.1 24.2356 52.5 35.5 52.5ZM35.5 0C26.2456 0 18.75 7.83125 18.75 17.5C18.75 27.1688 26.2456 35 35.5 35C44.7544 35 52.25 27.1688 52.25 17.5C52.25 7.83125 44.7544 0 35.5 0ZM35.5 43.75C24.3194 43.75 2 49.6125 2 61.25V70H69V61.25C69 49.6125 46.6806 43.75 35.5 43.75Z"
        fill="black"
      />
    </svg>
  );
};
const earth = ({ size }) => {
  return (
    <svg
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z" />
    </svg>
  );
};
const solutions = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_76_11)">
        <path
          d="M63 17.6316H55.37C55.755 16.6526 56 15.5789 56 14.4737C56 9.23158 51.31 5 45.5 5C41.825 5 38.64 6.70526 36.75 9.26316L35 11.3789L33.25 9.23158C31.36 6.70526 28.175 5 24.5 5C18.69 5 14 9.23158 14 14.4737C14 15.5789 14.245 16.6526 14.63 17.6316H7C3.115 17.6316 0.035 20.4421 0.035 23.9474L0 58.6842C0 62.1895 3.115 65 7 65H63C66.885 65 70 62.1895 70 58.6842V23.9474C70 20.4421 66.885 17.6316 63 17.6316ZM45.5 11.3158C47.425 11.3158 49 12.7368 49 14.4737C49 16.2105 47.425 17.6316 45.5 17.6316C43.575 17.6316 42 16.2105 42 14.4737C42 12.7368 43.575 11.3158 45.5 11.3158ZM24.5 11.3158C26.425 11.3158 28 12.7368 28 14.4737C28 16.2105 26.425 17.6316 24.5 17.6316C22.575 17.6316 21 16.2105 21 14.4737C21 12.7368 22.575 11.3158 24.5 11.3158ZM63 58.6842H7V52.3684H63V58.6842ZM63 42.8947H7V27.1053C7 25.3684 8.575 23.9474 10.5 23.9474H24.78L19.6 30.3263C18.445 31.7474 18.795 33.7368 20.37 34.7474C21.91 35.7579 24.115 35.4421 25.235 34.0526L35 22.0526L44.765 34.0526C45.885 35.4421 48.09 35.7579 49.63 34.7474C51.205 33.7368 51.555 31.7474 50.4 30.3263L45.22 23.9474H59.5C61.425 23.9474 63 25.3684 63 27.1053V42.8947Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_76_11">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const Icon = ({ name, size = 24 }) => {
  const icon = {
    menu,
    menuClose,
    bg,
    team,
    profil,
    solutions,
    earth
  };
  const Component = icon[name];
  return <Component size={size} />;
};

export { Icon };
